module.exports = __webpack_public_path__ + "public/StoreIcon/Dropdownwithcircle20x20.svg?f226df98";